<template>
	<footer>
		<div class="wrapper footer-wrapper">
			<div class="footer-left">
				<h5 class="tertiary-heading"> {{ locationData.display_name }} </h5>
				<ul>
					<li>
						<h6 class="tertiary-copy"> {{ locationData.address_line_1 }} </h6>
					</li>
					<li>
						<h6 class="tertiary-copy"> {{ locationData.city }}, {{ locationData.province}} </h6>
					</li>
					<li>
						<h6 class="tertiary-copy"> {{ locationData.postal_code }}</h6>
					</li>
					<li>
						<h6 class="tertiary-copy"> {{ locationData.country }} </h6>
					</li>
					<li>
						<div class="keyline"></div>
					</li>
					<li>
						<h6 class="tertiary-copy"> {{ locationData.phone }} </h6>
					</li>
					<h6 class="tertiary-copy"> {{ locationData.email }}</h6>
					<li>
						<div class="keyline"></div>
					</li>
				</ul>
				
			</div>
			<div class="footer-right">
				<h5 class="tertiary-heading">Hours of Operation</h5>
				<ul>
					<li v-for="day in locationHours">
						<h6 class="tertiary-copy">
						<div style="width:80px;display:inline-block;float-left"> 
							{{ day.day_name}}
						</div> 
						<div style="display:inline-block;float-left">
							{{ return12H(day.open_time)}} - {{ return12H(day.close_time) }}
						</div>
						</h6>
					</li>
				</ul>
			</div>
		</div>
	</footer>
</template>

<script>
import Location from '@/controllers/Location'
export default {
	name: 'MyFooter',
	data () {
		return {
			locationData: {},
			locationHours: []
		}
	},
	mounted () {
		this.getHours()
		this.getLocation()
	},
	methods: {
		return12H (val) {
			console.log(val)
			let arr = val.split(':')
			let type = 'am'
			if (arr[0] > 12) {
				type = 'pm'
				arr[0] = arr[0] - 12
			} else {
				arr[0] = arr[0] - 0
			}
			return arr[0] + ':' + arr[1] + type
		},
		getHours () {
			Location.getLocationHours().then(response => {
				this.locationHours = response.payload
			}).catch(e => {})
		},
		getLocation () {
			Location.getLocation().then(response => {
				this.locationData = response.payload
			}).catch(e => {})
		}
	}
}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';
	.tertiary-heading {
		font-size: 3rem;
	}
	.tertiary-copy {
		font-size: 1.5rem;
		line-height: 1.8rem;
	}
	footer {
		background: $primary-color;
		bottom: 0;
		min-height:200px;
		width: 100vw;
	}

	.footer-wrapper {
		font-size: 18px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding: 20px 0;
		color: white;
		@media (max-width: 500px) {
			flex-direction: column;
		}
	}

	.footer-left, .footer-right {
		width: 45%;
		@media (max-width: 500px) {
			width: 90%;
			margin: 0 auto;
			text-align: center;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/MyFooter.vue